module.exports = __webpack_public_path__ + "img/19.3cd5fb5.png";